export default {"src":"/_next/static/media/google-play.0b225d09.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};